import { render, staticRenderFns } from "./upgrade_rules.vue?vue&type=template&id=2b1a1336&scoped=true"
import script from "./upgrade_rules.vue?vue&type=script&lang=js"
export * from "./upgrade_rules.vue?vue&type=script&lang=js"
import style0 from "./upgrade_rules.vue?vue&type=style&index=0&id=2b1a1336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1a1336",
  null
  
)

export default component.exports